
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import DefaultData from '../../CompanyData/DefaultData'; // Adjust path if needed

const UmrahTabs = (props) => {
    const { user } = useAuth();
    const baseTabStyle = { border: 'none', fontWeight: '500', padding: '0.75rem 1.5rem', borderRadius: '0.375rem 0.375rem 0 0' };
    const inactiveTabStyle = { ...baseTabStyle, backgroundColor: 'transparent', color: DefaultData.THEMECOLOR3, opacity: 2 };
    const activeTabStyle = { ...baseTabStyle, backgroundColor: DefaultData.THEMECOLOR2, color: DefaultData.THEMECOLOR3 };
    const getStyle = (pageName) => (props.pageName === pageName ? activeTabStyle : inactiveTabStyle);

    return (
      <div style={{ backgroundColor: DefaultData.THEMECOLOR5, padding: '0 1rem', borderBottom: `1px solid ${DefaultData.THEMECOLOR2}` }}>
        <ul className="nav nav-tabs" style={{ borderBottom: 'none' }}>
            <li className="nav-item" role="presentation">
                <Link to={"/umrah"} className="nav-link" style={getStyle("UMRAHPACKAGE")}>CREATE UMRAH</Link>
            </li>
            <li className="nav-item" role="presentation">
                <Link to={"/umrahlist"} className="nav-link" style={getStyle("UMRAHPACKAGES")}>UMRAH PACKAGES</Link>
            </li>  
            {user && user.isWebsite && (
              <li className="nav-item" role="presentation">
                  <Link to={"/websiteumrahpackages"} className="nav-link" style={getStyle("WEBSITEUMRAHPACKAGES")}>WEBSITE UMRAH PACKAGES</Link>
              </li>
            )}              
            <li className="nav-item" role="presentation">
                <Link to={"/umrahenquiry"} className="nav-link" style={getStyle("UMRAH ENQUIRIES")}>UMRAH ENQUIRIES</Link>
            </li>
            {/* <li className="nav-item" role="presentation">
                <Link to={"/packagedates"} className={props.pageName === "PACKAGEDATES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE DATES</Link>
            </li> */}
        </ul>
      </div>
    );
};

export default UmrahTabs;